window.$ = window.jQuery = require("jquery");
import Vue from "vue";
import ErrorList from "../components/ErrorList";

export function ErrorManager() {
    var self = this;

    function pushError(errors, key, value) {
        if (typeof key === "string" && key != "message") {
            if (key != "success") {
                errors.push({ title: key, message: value });
            }
        } else {
            errors.push({ message: value });
        }
    }

    self.ajaxError = function(err, container) {
        if (err && err.responseJSON) {
            if (err.responseJSON.error) {
                self.errorHtml(err.responseJSON.error, container);
            } else {
                self.errorHtml(err.responseJSON, container);
            }
        } else if (err && err.statusText) {
            self.displayErrors(
                [{ message: "Could not process request.", details: err.statusText }],
                container
            );
        } else {
            self.displayErrors([{ message: "Could not process request." }], container);
        }
    };

    self.errorHtml = function(obj, container) {
        // Flatten to array of messages
        var errors = [];

        $.each(obj, function(key, value) {
            if ($.isArray(value) || typeof value === "object") {
                $.each(value, function(key, value) {
                    pushError(errors, key, value);
                });
            } else {
                pushError(errors, key, value);
            }
        });

        return self.displayErrors(errors, container);
    };

    self.displayErrors = function(errors, container) {
        let html = "";
        if (errors && errors.length) {
            const ctor = Vue.extend(ErrorList);
            const vm = new ctor({
                propsData: {
                    errors: errors
                }
            }).$mount();
            html = vm.$el;
            vm.$destroy();
        }
        if (container && $(container).length) {
            $(container).html(html);
            $(container)[0].scrollIntoView(false);
        }
        return html;
    };
}

export const $err = new ErrorManager();
